import { ReactKeycloakProvider } from "@react-keycloak/web";
import { ReactNode } from "react";
import keycloak from "./config/keycloak.js";

interface Props {
  children: ReactNode;
}

const KeycloakProvider = ({ children }: Props) => {
  const initOptions = {
    pkceMethod: "S256" as const,
    checkLoginIframe: false,
    onLoad: "login-required" as const,
    silentCheckSsoRedirectUri: window.location.origin + "/silent-check-sso.html",
  };

  const handleOnEvent = (event: string, error?: unknown) => {
    console.log("Keycloak Event:", event, error || "");
    if (error) {
      console.error("Keycloak Error in event:", error);
    }
    // Nothing else refreshes the access token proactively — without this,
    // a token that expires while the tab is idle stays expired until the
    // next API call happens to trigger a refresh, so requests in between
    // (e.g. a websocket reconnect) go out with a dead token.
    if (event === "onTokenExpired") {
      keycloak.updateToken(30).catch((err) => {
        console.error("Keycloak token refresh failed:", err);
      });
    }
  };

  const handleTokens = (tokens: any) => {
    console.log("Keycloak Tokens Updated:", {
      hasIdToken: !!tokens.idToken,
      hasToken: !!tokens.token,
      hasRefreshToken: !!tokens.refreshToken
    });
  };

  const LoadingComponent = (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
        <p className="text-gray-600">Loading authentication...</p>
      </div>
    </div>
  );

  return (
    <ReactKeycloakProvider
      authClient={keycloak}
      initOptions={initOptions}
      onEvent={handleOnEvent}
      onTokens={handleTokens}
      LoadingComponent={LoadingComponent}
    >
      {children}
    </ReactKeycloakProvider>
  );
};

export default KeycloakProvider;
